import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
  row-gap: 6px;
  display: grid;
  border-bottom: 1px solid ${({theme}) => `
    ${theme.variables.borderColor};
  `};
  box-sizing: border-box;
  padding: 20px;
`;

export const Question = styled.strong`
  line-height: 20px;
  font-weight: 500;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 18px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
